import { COLORS, paddingMd } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

interface IHasErrorProps {
  hasError?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  padding: 30rem 15rem;
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 300;
  color: ${COLORS.BLACK};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${paddingMd};
  width: 100%;
  max-height: 500rem;
  overflow-y: auto;
  gap: 10rem;
  padding: 0 15rem;
`;

export const LanguageGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8rem;
  width: 100%;
`;

export const LanguageLabel = styled.label`
  font-weight: 600;
  font-size: 16rem;
  line-height: 21rem;
  color: ${COLORS.BLACK};
`;

export const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 80rem;
  font-family: inherit;
  font-size: 14rem;
  color: ${COLORS.BLACK};
  background-color: ${COLORS.WHITE};
  border: 1rem solid
    ${({ hasError }: IHasErrorProps) =>
      hasError ? COLORS.RED_100 : COLORS.BORDER};
  border-radius: 8rem;
  padding: 10rem;
  resize: vertical;
  outline: none;
  transition: border 0.2s;

  &:hover,
  &:focus {
    border-color: ${({ hasError }: IHasErrorProps) =>
      hasError ? COLORS.RED_100 : COLORS.GREEN};
  }
`;

export const HelperRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 16rem;
`;

export const CharacterCount = styled.span`
  font-size: 12rem;
  color: ${({ hasError }: IHasErrorProps) =>
    hasError ? COLORS.RED_100 : COLORS.BLACK};
`;

export const ErrorMessage = styled.span`
  font-size: 12rem;
  color: ${COLORS.RED_100};
`;

export const ApplyWrapper = styled.div`
  display: flex;
  padding-top: 30rem;
  align-items: center;
  justify-content: center;
  gap: 30rem;

  ${respondTo.smallPhone`
    flex-direction: column;
    gap: 10rem;
  `}
`;
